import { Link } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import user5 from './../../../../images/users/user5.jpg';
import user6 from './../../../../images/users/user6.jpg';
import user7 from './../../../../images/users/favicon1.png';

import { useDispatch, useSelector } from 'react-redux';
import { get_data_Review_Data } from '../../../../store/actions/CommanAction';
import { useEffect, useState } from 'react';

function SampleNextArrow(props) {

	const { onClick } = props;
	return (
		<div className="owl-nav">
			<div className="owl-next fas fa-arrow-right" onClick={onClick} />
		</div>
	);
}


function SamplePrevArrow(props) {
	const { onClick } = props;
	return (
		<div className="owl-nav">
			<div className=" owl-prev fas fa-arrow-left" onClick={onClick} style={{ zIndex: 1 }} />
		</div>
	);
}

const LatestReview = ({ startDate, endDate }) => {
	const [loading, setloading] = useState(false);
	const dispatch = useDispatch()
	const feedbackdata = useSelector((state) => state.feedBackReducer.GetReviewData)
	
	const filteredData = feedbackdata?.filter(
		item => item.Comments && item.Comments.trim() !== ""
	);

	const settings = {
		dots: false,
		arrows: true,
		infinite: filteredData?.length > 1,
		slidesToShow: filteredData?.length >= 3 ? 3 : filteredData?.length,
		slidesToScroll: 1,
		nextArrow: <SampleNextArrow />,
		prevArrow: <SamplePrevArrow />,
		speed: 3000,

		responsive: [
			{
				breakpoint: 1560,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 1400,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	};

	useEffect(() => {
		dispatch(get_data_Review_Data(setloading, "",  startDate, endDate, "", "" ))
	}, [startDate, endDate])
	const getTimeAgo = (time) => {
		const now = new Date();
		const past = new Date(time);
		const diff = Math.floor((now - past) / 1000);

		if (diff < 60) return `${diff} sec ago`;
		if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
		if (diff < 86400) return `${Math.floor(diff / 3600)} hr ago`;
		if (diff < 2592000) return `${Math.floor(diff / 86400)} days ago`;

		return past.toLocaleDateString();
	};

	
	return (
		<>
			<Slider
				className="front-view-slider"
				{...settings}
			>
				{
					feedbackdata
						?.filter(item => item.Comments && item.Comments.trim() !== "")
						?.map((item, index) => (

							<div key={index} className="px-2">

								<div
									className="customers border"
									style={{
										height: "180px",
										display: "flex",
										flexDirection: "column",
										justifyContent: "space-between",
										padding: "12px",
										borderRadius: "10px"
									}}
								>

									<p
										style={{
											display: "-webkit-box",
											WebkitLineClamp: 3,
											WebkitBoxOrient: "vertical",
											overflow: "hidden",
											textOverflow: "ellipsis",
											minHeight: "40px"
										}}
									>
										{item.Comments}
									</p>

									<div className="d-flex justify-content-between align-items-center mt-4">

										<div className="customer-profile d-flex">
											

											<img
												id="Image"
												src={
													item.AvatarUrl

														? `https://${item.AvatarUrl.replace(/\\/g, "/")}`

														: user7
												}
												alt={"image"}

											/>

											<div className="ms-3">
												<h5 className="mb-0">{item.Astrologers}(Astrologer)</h5>
												<span style={{ fontSize: "12px" }}>
													{getTimeAgo(item.CreatedTime)}
												</span>
											</div>
										</div>

										<div className="customer-button text-nowrap">
										
										</div>

									</div>

								</div>
							</div>

						))
				}
			</Slider>
		</>
	);
}
export default LatestReview;